import { render, staticRenderFns } from "./PaymentGateWayShow.vue?vue&type=template&id=57fa8b0c&"
import script from "./PaymentGateWayShow.vue?vue&type=script&lang=js&"
export * from "./PaymentGateWayShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports